<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<text-field label="Name of Involved" :value.sync="contact.name"/>
			</div>
			<div class="col-sm-12 col-md-6">
				<text-field label="Phone Number" placeholder="Example: XXXXXXXXXX" :value.sync="contact.phone"/>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<text-field label="Mailing Address" :value.sync="contact.address"/>
			</div>
			<div class="col-sm-12 col-md-6">
				<text-field type="email" label="Confidential Email Address" :value.sync="contact.email"/>
			</div>
		</div>
	</div>
</template>

<script>
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

export default {
	name: 'ContactInformation',
	components: {
		TextField,
		SelectField,
	},
	props: {
		contact: {
			required: true,
			type: Object,
		},
	},
	data() {
		return {
			pcontact: this.contact || {
				name: '',
				phone: '',
				address: '',
				email: '',
			},
		};
	},
	watch: {
		pcontact: {
			handler: newvalue => {
				this.contact = newvalue;
			},
			deep: true,
		},
	},
};
</script>
